import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

const PACCHETTI = ['START', 'ADVANCED', 'ADVANCED_COLLISIONE', 'ADVANCED_KASKO']
const PACCHETTI_LABEL = {
  START: 'START (Base)',
  ADVANCED: 'ADVANCED',
  ADVANCED_COLLISIONE: 'ADVANCED + Collisione',
  ADVANCED_KASKO: 'ADVANCED + Kasko',
}
const ZONE = [1, 2, 3]
const DURATE = [12, 24, 36]

export default function AdminLloydPlusTassi() {
  const [tassi, setTassi] = useState([])
  const [edits, setEdits] = useState({})
  const [zona, setZona] = useState(1)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('lloyd_plus_tassi').select('*')
    setTassi(data || [])
    setLoading(false)
  }

  function k(pacchetto, z, durata) { return `${pacchetto}||${z}||${durata}` }

  function getVal(pacchetto, z, durata) {
    const key = k(pacchetto, z, durata)
    if (edits[key] !== undefined) return edits[key]
    const row = tassi.find(t => t.pacchetto === pacchetto && t.zona === z && t.durata_mesi === durata)
    return row != null ? row.tasso : ''
  }

  async function saveAll() {
    setSaving(true)
    for (const [key, val] of Object.entries(edits)) {
      const [pacchetto, z, durata] = key.split('||')
      await supabase.from('lloyd_plus_tassi')
        .update({ tasso: parseFloat(val) })
        .eq('pacchetto', pacchetto)
        .eq('zona', parseInt(z))
        .eq('durata_mesi', parseInt(durata))
    }
    setEdits({})
    clearTariffeCache()
    await load()
    setSaving(false)
  }

  if (loading) return <div className="loading">Caricamento...</div>
  const dirty = Object.keys(edits).length > 0

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Tassi Lloyd's Plus</h1>
          <p>Tassi imponibili per pacchetto × zona × durata. La formula applica: sconto sat 20% → +13.5% imposte → ×valore → +tutela legale → +20% diritti → +commissione.</p>
        </div>
        {dirty && (
          <button className="btn btn-primary" onClick={saveAll} disabled={saving}>
            {saving ? 'Salvataggio...' : `Salva ${Object.keys(edits).length} modifiche`}
          </button>
        )}
      </div>

      <div className="card">
        <div className="tabs">
          {ZONE.map(z => (
            <div key={z} className={`tab ${zona === z ? 'active' : ''}`} onClick={() => setZona(z)}>
              Zona {z}
            </div>
          ))}
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Pacchetto</th>
                {DURATE.map(d => <th key={d}>{d} mesi</th>)}
              </tr>
            </thead>
            <tbody>
              {PACCHETTI.map(p => (
                <tr key={p}>
                  <td><strong>{PACCHETTI_LABEL[p]}</strong></td>
                  {DURATE.map(d => {
                    const key = k(p, zona, d)
                    const val = getVal(p, zona, d)
                    const isDirty = edits[key] !== undefined
                    return (
                      <td key={d}>
                        <input
                          type="number" step="0.0001" value={val}
                          onChange={e => setEdits(s => ({ ...s, [key]: e.target.value }))}
                          style={{ width: 100, background: isDirty ? '#FFF7E5' : 'transparent' }}
                        />
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
